<template>
  <a-modal
    v-model="visible"
    :title="title"
    :footer="null"
    :closable="false"
    class="adaptive-modal"
    @cancel="closeModal"
  >
    <div class="d-flex flex-column">
      <p v-if="text" class="font-size-16" v-html="text" />
      <div class="d-flex flex-column justify-content-center">
        <a-form-model :model="form" ref="form">
          <span>To confirm, please type <b>DELETE</b> below</span>
          <a-form-model-item
            prop="delete"
            :colon="false"
            :rules="[{ required: true, message: 'To confirm, please type DELETE', trigger: ['change'] }]"
          >
            <a-input
              v-model="form.delete"
              placeholder="type DELETE"
              size="large"
              :disabled="loading"
            />
          </a-form-model-item>
        </a-form-model>
      </div>
      <a-row class="adaptive-modal__footer">
        <div class="d-flex align-items-center justify-content-end">
          <a-button @click="closeModal" class="mr-3">
            Cancel
          </a-button>
          <a-button
            type="danger"
            :disabled="loading"
            :loading="loading"
            @click="action"
          >
            Delete
          </a-button>
        </div>
      </a-row>
    </div>
  </a-modal>
</template>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
  },
  data: () => ({
    form: {
      delete: '',
    },
  }),
  watch: {
    show: {
      handler(val) {
        if (!val) {
          this.visible = false
          return
        }
        this.visible = true
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
  },
  methods: {
    validateDelete(_, value, callback) {
      if (value === 'DELETE') {
        callback()
      } else {
        callback(new Error('Please type DELETE exactly'))
      }
    },
    action() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return false
        }
        if (this.form.delete !== 'DELETE') {
          const field = this.$refs.form.fields.find(f => f.prop === 'delete')
          if (field) {
            field.validateMessage = 'Please type DELETE exactly'
            field.validateState = 'error'
          }
          return
        }

        this.$emit('confirm')
      })
    },
    closeModal() {
      this.$emit('close')
    },
  },
}
</script>
